import PropTypes from 'prop-types';
import { memo } from 'react';
import { useIntl } from 'react-intl';
import {
  conversionNumbersListSourceToTarget,
  conversionNumbersListTargetToSource,
  convertorTypes,
} from 'constants/currency';

import {
  ConversionNumbersListWrapper,
  Title,
  ConversionItem,
  ConversionItemLink,
} from './styles';
import { getLocaleUrlPath } from '../../utils';

export const ConversionNumbersList = memo(
  ({
    source: { code: sourceCode, type: sourceType },
    target: { code: targetCode, type: targetType },
    rates: { sourceRate, targetRate },
  }) => {
    const { formatNumber, locale } = useIntl();

    const formattedTargetValue = ({ value, type, code, style }) => {
      return formatNumber(value, {
        maximumFractionDigits: type === convertorTypes.CRYPTO ? 8 : 2,
        style: style || 'currency',
        currency: code,
        currencyDisplay: 'code',
        // format: 'de-DE',
      });
    };

    const getUrl = (number, targetCode, sourceCode) => {
      if (number === 1) {
        return `https://minfin.com.ua${getLocaleUrlPath(
          locale
        )}/currency/converter/${sourceCode.toLocaleLowerCase()}-${targetCode.toLocaleLowerCase()}/`;
      }

      return `https://minfin.com.ua${getLocaleUrlPath(
        locale
      )}/currency/converter/${number}-${sourceCode.toLocaleLowerCase()}-to-${targetCode.toLocaleLowerCase()}/`;
    };

    return (
      <ConversionNumbersListWrapper>
        <div>
          <Title>{`${sourceCode}/${targetCode}`}</Title>
          <div>
            {conversionNumbersListSourceToTarget.map(number => (
              <ConversionItem>
                <ConversionItemLink
                  href={getUrl(number, targetCode, sourceCode)}
                >
                  {formattedTargetValue({
                    value: number,
                    code: sourceCode,
                    style: 'decimal',
                  })}
                  {` `}
                  {sourceCode}
                </ConversionItemLink>

                <span>
                  {formattedTargetValue({
                    value: (number * sourceRate) / targetRate,
                    type: targetType,
                    code: targetCode,
                  })}
                </span>
              </ConversionItem>
            ))}
          </div>
        </div>

        <div>
          <Title>{`${targetCode}/${sourceCode}`}</Title>
          <div>
            {conversionNumbersListTargetToSource.map(number => {
              return (
                <ConversionItem>
                  <ConversionItemLink
                    href={getUrl(number, sourceCode, targetCode)}
                  >
                    {formattedTargetValue({
                      value: number,
                      code: targetCode,
                      style: 'decimal',
                    })}
                    {` `}
                    {targetCode}
                  </ConversionItemLink>

                  <span>
                    {formattedTargetValue({
                      value:
                        sourceRate === '1.00'
                          ? number * targetRate
                          : number / sourceRate,
                      type: sourceType,
                      code: sourceCode,
                    })}
                  </span>
                </ConversionItem>
              );
            })}
          </div>
        </div>
      </ConversionNumbersListWrapper>
    );
  }
);

ConversionNumbersList.propTypes = {
  currency: PropTypes.string.isRequired,
  rates: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default ConversionNumbersList;
